import { types } from 'mobx-state-tree';
import { SpatialReference } from './spatialReference';

export const PointGeometry = types.model('PointGeometry', {
  gid: types.maybeNull(types.string),
  spatialReference: SpatialReference,
  x: types.maybe(types.number),
  y: types.maybe(types.number)
});
